<template>
  <div>
    <v-autocomplete
      v-model="localValue"
      :items="departmentOptions"
      :loading="isLoading"
      item-text="label"
      item-value="id"
      :label="label || $t('STOCK.PRODUCT_CATEGORIES.DEPARTMENT')"
      clearable
      :search-input.sync="search"
      :error-messages="errorMessages"
      @change="emitChange"
      @update:search-input="handleSearch"
    ></v-autocomplete>
  </div>
</template>

<script>
import { debounce } from "lodash";
import { GET_STOCK_PRODUCT_DEPARTMENT_OPTIONS } from "@/store/stock/stockProductDepartments.module";

export default {
  name: "StockProductDepartmentPicker",
  props: {
    value: {
      default: null,
    },
    initialDepartment: {
      type: Object,
      default: null,
    },
    errorMessages: {
      type: Array,
      default: () => [],
    },
    label: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      localValue: this.value,
      departmentOptions: [],
      search: "",
      isLoading: false,
    };
  },
  watch: {
    value(value) {
      this.localValue = value;
    },
    initialDepartment: {
      handler(department) {
        this.mergeDepartmentOptions(department ? [department] : []);
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    this.loadDepartments("");
  },
  methods: {
    handleSearch: debounce(function (search) {
      this.loadDepartments(search || "");
    }, 350),
    loadDepartments(search) {
      this.isLoading = true;
      return this.$store
        .dispatch(GET_STOCK_PRODUCT_DEPARTMENT_OPTIONS, { search })
        .then((response) => {
          this.departmentOptions = response.data || [];
          this.mergeDepartmentOptions(this.initialDepartment ? [this.initialDepartment] : []);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    mergeDepartmentOptions(departments) {
      const byId = {};
      [...this.departmentOptions, ...(departments || [])].forEach((department) => {
        if (department && department.id) {
          byId[department.id] = department;
        }
      });
      this.departmentOptions = Object.values(byId);
    },
    emitChange() {
      this.$emit("input", this.localValue);
      this.$emit("change");
    },
  },
};
</script>
